import React, { useContext } from "react";
import { WebsiteContext } from "../../context/AppContext";
import contactImage from "../../assets/contact.png";
import {
  FaPhoneAlt,
  FaWhatsapp,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { motion } from "framer-motion";
import "../../styles/contact.css";

const ContactDetails = () => {
  const { isMobileView } = useContext(WebsiteContext);

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.15 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    show: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 60, damping: 15 },
    },
  };

  const graphicVariants = {
    hidden: { opacity: 0, x: isMobileView ? 0 : 50, scale: 0.95 },
    show: {
      opacity: 1,
      x: 0,
      scale: 1,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  return (
    <div className="contact_section_wrapper">
      <motion.div
        className="contact_header"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="contact_title">Contact Details</h2>
      </motion.div>

      <div className="contact_grid">
        {/* Left Column: Info Cards */}
        <motion.div
          className="contact_info_container"
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
        >
          <motion.div variants={itemVariants}>
            <p className="contact_intro">For more please contact 🙏</p>
            <h3 className="contact_person">Sivakumar. G</h3>
          </motion.div>

          <motion.a
            href="tel:+919655590136"
            className="contact_card call_card"
            variants={itemVariants}
          >
            <div className="contact_icon_wrapper">
              <FaPhoneAlt />
            </div>
            <div className="contact_text_wrapper">
              <span className="contact_label">Call Us Directly</span>
              <span className="contact_value">+91 96555 90136</span>
            </div>
          </motion.a>

          <motion.a
            href="https://wa.me/919655590136?text=Hello%20SSS%20KOVAI%20TRAVELS%2C%20I%20would%20like%20to%20book%20a%20cab."
            target="_blank"
            rel="noreferrer"
            className="contact_card whatsapp_card"
            variants={itemVariants}
          >
            <div className="contact_icon_wrapper">
              <FaWhatsapp />
            </div>
            <div className="contact_text_wrapper">
              <span className="contact_label">Message on WhatsApp</span>
              <span className="contact_value">+91 96555 90136</span>
            </div>
          </motion.a>

          <motion.a
            href="mailto:ssscovaitravels4@gmail.com"
            className="contact_card email_card"
            variants={itemVariants}
          >
            <div className="contact_icon_wrapper">
              <FaEnvelope />
            </div>
            <div className="contact_text_wrapper">
              <span className="contact_label">Email Us</span>
              <span className="contact_value">ssscovaitravels4@gmail.com</span>
            </div>
          </motion.a>

          <motion.div
            className="contact_card location_card"
            variants={itemVariants}
          >
            <div className="contact_icon_wrapper">
              <FaMapMarkerAlt />
            </div>
            <div className="contact_text_wrapper">
              <span className="contact_label">Office Address</span>
              <span
                className="contact_value"
                style={{
                  fontSize: "0.9rem",
                  lineHeight: 1.4,
                  marginTop: "8px",
                }}
              >
                Otthakkalmandapam Velanthavalam Road
                <br />
                Valukkuparai PO, Coimbatore
                <br />
                Tamilnadu - 641032
              </span>
            </div>
          </motion.div>

          <motion.a
            href="tel:+919655590136"
            className="contact_cta_btn"
            variants={itemVariants}
          >
            Call Now!
          </motion.a>
        </motion.div>

        {/* Right Column: Graphic Image */}
        <motion.div
          className="contact_graphic_container"
          variants={graphicVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
        >
          <img
            src={contactImage}
            alt="Contact SSS Covai Travels"
            className="contact_graphic"
          />
        </motion.div>
      </div>
    </div>
  );
};

export default ContactDetails;
